//BUYERS Listing
export const FETCH_FROM_OP_LISTING_FAILURE = 'FETCH_FROM_OP_LISTING_FAILURE';
export const FETCH_FROM_OP_LISTING_SUCCESS = 'FETCH_FROM_OP_LISTING_SUCCESS';

export const RESET = 'RESET';
